/* =========================================================
   VALARNI – COLLECTION PAGE
   Pills scroll · drawers · sort · filters · price slider
   Load more (AJAX) · wishlist hearts
   ========================================================= */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('vlc');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var html = document.documentElement;

    /* ---------------- Category pills: arrows ---------------- */
    root.querySelectorAll('[data-vlc-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-vlc-track]');
      var prev = wrap.querySelector('[data-dir="-1"]');
      var next = wrap.querySelector('[data-dir="1"]');
      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = next.hidden = !overflow;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      [prev, next].forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.7, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      var active = track.querySelector('.is-active');
      if (active) track.scrollLeft = active.offsetLeft - track.clientWidth / 2 + active.offsetWidth / 2;
      // stop theme swipe/drawer scripts from stealing the horizontal swipe
      ['touchstart', 'touchmove'].forEach(function (ev) {
        track.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      update();
    });

    /* ---------------- Drawers ---------------- */
    var scrim = root.querySelector('[data-vlc-scrim]');
    var lastTrigger = null;
    function openDrawer(name, trigger) {
      var d = root.querySelector('[data-vlc-drawer="' + name + '"]');
      if (!d) return;
      lastTrigger = trigger || null;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      scrim.classList.add('is-on');
      html.classList.add('vlc-lock');
      setTimeout(function () { var c = d.querySelector('[data-vlc-close]'); if (c) c.focus({ preventScroll: true }); }, 60);
    }
    function closeDrawers() {
      root.querySelectorAll('.vlc-drawer.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
      });
      scrim.classList.remove('is-on');
      html.classList.remove('vlc-lock');
      if (lastTrigger) lastTrigger.focus({ preventScroll: true });
    }
    root.querySelectorAll('[data-vlc-open]').forEach(function (b) {
      b.addEventListener('click', function () { openDrawer(b.dataset.vlcOpen, b); });
    });
    root.querySelectorAll('[data-vlc-close]').forEach(function (b) { b.addEventListener('click', closeDrawers); });
    scrim.addEventListener('click', closeDrawers);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

    /* ---------------- Sort ---------------- */
    var applySort = root.querySelector('[data-vlc-apply-sort]');
    if (applySort) {
      applySort.addEventListener('click', function () {
        var checked = root.querySelector('input[name="vlc-sort"]:checked');
        var url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (checked) url.searchParams.set('sort_by', checked.value); else url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      });
    }

    /* ---------------- Price slider ---------------- */
    var priceBox = root.querySelector('[data-vlc-price]');
    var priceMax = 300;
    if (priceBox) {
      // 300 € converted to the active currency, rounded UP to the next hundred
      var rate = 1;
      try { rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1; } catch (e) {}
      var base = parseFloat(priceBox.dataset.base) || 300;
      priceMax = Math.max(100, Math.ceil((base * rate) / 100) * 100);

      var rmin = priceBox.querySelector('[data-vlc-rmin]');
      var rmax = priceBox.querySelector('[data-vlc-rmax]');
      var imin = priceBox.querySelector('[data-vlc-imin]');
      var imax = priceBox.querySelector('[data-vlc-imax]');
      var fill = priceBox.querySelector('[data-vlc-fill]');

      [rmin, rmax].forEach(function (r) { r.max = priceMax; });
      imax.placeholder = priceMax;

      var startMin = priceBox.dataset.min !== '' ? Math.max(0, Math.min(priceMax, parseFloat(priceBox.dataset.min))) : 0;
      var startMax = priceBox.dataset.max !== '' ? Math.max(0, Math.min(priceMax, parseFloat(priceBox.dataset.max))) : priceMax;
      rmin.value = startMin; rmax.value = startMax;
      imin.value = priceBox.dataset.min !== '' ? startMin : '';
      imax.value = priceBox.dataset.max !== '' ? startMax : '';

      function paint() {
        var a = Number(rmin.value), b = Number(rmax.value);
        fill.style.left = (a / priceMax * 100) + '%';
        fill.style.right = (100 - b / priceMax * 100) + '%';
        rmin.style.zIndex = a > priceMax - 10 ? 3 : 2;
      }
      rmin.addEventListener('input', function () {
        if (Number(rmin.value) > Number(rmax.value)) rmin.value = rmax.value;
        imin.value = Number(rmin.value) > 0 ? rmin.value : '';
        paint();
      });
      rmax.addEventListener('input', function () {
        if (Number(rmax.value) < Number(rmin.value)) rmax.value = rmin.value;
        imax.value = Number(rmax.value) < priceMax ? rmax.value : '';
        paint();
      });
      imin.addEventListener('input', function () {
        var v = imin.value === '' ? 0 : Math.max(0, Math.min(Number(imin.value), Number(rmax.value)));
        rmin.value = v; paint();
      });
      imax.addEventListener('input', function () {
        var v = imax.value === '' ? priceMax : Math.max(Number(rmin.value), Math.min(Number(imax.value), priceMax));
        rmax.value = v; paint();
      });
      imin.addEventListener('change', function () { if (imin.value !== '' && Number(imin.value) > Number(rmax.value)) imin.value = rmax.value; });
      imax.addEventListener('change', function () { if (imax.value !== '' && Number(imax.value) < Number(rmin.value)) imax.value = rmin.value; });
      paint();
    }

    /* ---------------- Colour swatches: one swatch = all its synonyms (Noir + Black…) ---------------- */
    root.querySelectorAll('[data-vlc-swatch]').forEach(function (sw) {
      var btn = sw.querySelector('.vlc-swatch__btn');
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        sw.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = on; });
      });
    });

    /* ---------------- Filter form: clean empty params ---------------- */
    var form = root.querySelector('[data-vlc-filter-form]');
    if (form) {
      form.addEventListener('submit', function () {
        if (!priceBox) return;
        var imin = priceBox.querySelector('[data-vlc-imin]');
        var imax = priceBox.querySelector('[data-vlc-imax]');
        if (imin.value === '' || Number(imin.value) <= 0) imin.removeAttribute('name');
        // "Max" at the top of the slider means "no maximum" → products above it stay visible
        if (imax.value === '' || Number(imax.value) >= priceMax) imax.removeAttribute('name');
      });
    }

    /* ---------------- Load more (72 by 72) ---------------- */
    var grid = root.querySelector('[data-vlc-grid]');
    var more = root.querySelector('[data-vlc-more]');
    if (grid && more) {
      var btn = more.querySelector('[data-vlc-next]');
      var viewedEl = more.querySelector('[data-vlc-viewed]');
      var bar = more.querySelector('[data-vlc-progress]');
      var total = parseInt(root.querySelector('[data-vlc-total]').textContent, 10) || 0;
      var section = root.dataset.section;
      if (btn) {
        var label = btn.textContent;
        btn.addEventListener('click', function () {
          var next = btn.dataset.vlcNext;
          if (!next) return;
          btn.classList.add('is-loading');
          btn.textContent = (window.VL_T && VL_T['js.loading']) || 'Loading…';
          var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(section);
          fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (text) {
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var newGrid = doc.querySelector('[data-vlc-grid]');
              if (newGrid) {
                var frag = document.createDocumentFragment();
                Array.prototype.slice.call(newGrid.children).forEach(function (li) { frag.appendChild(li); });
                grid.appendChild(frag);
              }
              var viewed = grid.children.length;
              viewedEl.textContent = viewed;
              bar.style.width = (total ? Math.min(100, viewed / total * 100) : 100) + '%';
              var newBtn = doc.querySelector('[data-vlc-next]');
              if (newBtn && viewed < total) {
                btn.dataset.vlcNext = newBtn.dataset.vlcNext;
                btn.textContent = label;
                btn.classList.remove('is-loading');
              } else {
                btn.remove();
              }
              syncHearts();
            })
            .catch(function () {
              btn.textContent = label;
              btn.classList.remove('is-loading');
            });
        });
      }
    }

    /* ---------------- Wishlist hearts ----------------
       Stored in localStorage "vl_wishlist" (list of product handles).
       Fires "wishlist:update" so the header counter refreshes.
       Hook for a future wishlist app: listen to "vlc:wishlist" on document. */
    function getWish() {
      try { var w = JSON.parse(localStorage.getItem('vl_wishlist') || '[]'); return Array.isArray(w) ? w : []; } catch (e) { return []; }
    }
    function setWish(list) {
      try { localStorage.setItem('vl_wishlist', JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('wishlist:update'));
    }
    function syncHearts() {
      var list = getWish();
      root.querySelectorAll('[data-vlc-wish]').forEach(function (b) {
        var on = list.indexOf(b.dataset.vlcWish) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? ((window.VL_T && VL_T['js.wish_remove']) || 'Remove from wishlist') : ((window.VL_T && VL_T['js.wish_add']) || 'Add to wishlist'));
      });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vlc-wish]');
      if (!b) return;
      e.preventDefault();
      var handle = b.dataset.vlcWish;
      var list = getWish();
      var i = list.indexOf(handle);
      var added = i === -1;
      if (added) list.push(handle); else list.splice(i, 1);
      setWish(list);
      syncHearts();
      b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      document.dispatchEvent(new CustomEvent('vlc:wishlist', { detail: { handle: handle, added: added } }));
    });
    window.addEventListener('storage', function (e) { if (e.key === 'vl_wishlist') syncHearts(); });
    syncHearts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();